import * as React from "react";
import Link from "next/link";
import { useOrchestrators } from "@nju/data-access-portal-orchestrator";
import { Icon } from "@nju/icons";
import { salesRoutes } from "@nju/routes";
import {
  A,
  BlockContent,
  Button,
  Modal,
  Separator,
  Text,
  useOverlay,
} from "@nju/ui";
import { CancelOrderModal } from "../../cancelOrder";
import { getMappedErrorCodeDescription } from "./utils";

export function MigrationImpossiblePage() {
  const multiOrder = useOrchestrators("multiOrder");
  const cancelOrderModal = useOverlay();
  const { id, multiOrderItems, currentMultiOrderItem } = multiOrder;
  const currentNumberMigrationStatus =
    multiOrderItems[currentMultiOrderItem - 1].legacy;
  const checkIfCodeIsRC001 =
    currentNumberMigrationStatus?.feasibilityCode &&
    currentNumberMigrationStatus.feasibilityCode === "RC001";

  return (
    <BlockContent grid="narrow">
      <Separator size="m" tone="invisible" />
      <div className="flex items-center flex-col pb-2">
        <Text
          align="center"
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {checkIfCodeIsRC001
            ? "przeniesienie numeru nie jest możliwe"
            : "migracja nie jest możliwa"}
        </Text>
        <Separator size="s" tone="invisible" />
        <div className="flex justify-center">
          <Icon
            className="w-[90px] h-[90px] only-mobile:w-[60px] only-mobile:h-[60px] "
            name={
              checkIfCodeIsRC001
                ? "calendar-alt-incricle-fail"
                : "hand-incircle-fail"
            }
          />
        </div>
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          <Text
            align="center"
            className="w-[530px]"
            display="block"
            size={{
              "@onlyMobile": "m",
              "@fromTablet": "l",
            }}
            weight="bold"
          >
            {getMappedErrorCodeDescription(currentNumberMigrationStatus)}
          </Text>
          {currentNumberMigrationStatus?.feasibilityCode && (
            <>
              <Separator size="xxs" tone="invisible" />
              {currentNumberMigrationStatus.feasibilityCode === "RC001" && (
                <Text>
                  Poinformuj go, że może przenieść numer samodzielnie, przez
                  aplikację.
                </Text>
              )}
              {currentNumberMigrationStatus.feasibilityCode !== "RC001" &&
                `Kod błędu: ${currentNumberMigrationStatus.feasibilityCode}.`}
            </>
          )}
        </Text>
      </div>
      <Separator size="m" />
      <div className="gap-2 flex flex-col from-tablet:flex-row justify-center pt-4">
        <Button
          display={{
            "@fromTablet": "inline",
          }}
          onPress={cancelOrderModal.open}
          size={{
            "@onlyMobile": "s",
          }}
          variant="secondary"
        >
          anuluj zamówienie
        </Button>
        <Link
          href={salesRoutes.idziemyDalej.get({ screenVariant: "failed" })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="primary"
          >
            przejdź dalej
          </A>
        </Link>
      </div>
      {cancelOrderModal.isOpened && (
        <Modal onClose={cancelOrderModal.close} title="anulowanie zamówienia">
          <CancelOrderModal
            mode="mobile"
            onClose={cancelOrderModal.close}
            orchestratorId={id}
          />
        </Modal>
      )}
      <Separator size="m" tone="invisible" />
    </BlockContent>
  );
}
